import { faAlignCenter, faAlignJustify, faAlignLeft, faAlignRight, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { $getSelection, $isRangeSelection, ElementFormatType, FORMAT_ELEMENT_COMMAND, LexicalEditor } from "lexical";
import ToolbarButton from "../../../components/ToolbarButton";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";

type Definition =
{
    command: typeof FORMAT_ELEMENT_COMMAND
    elementFormatType: ElementFormatType
    title: string
    icon: IconDefinition
}

export const Definitions =
{
    left:    { kind: 'element', elementFormatType: 'left' as ElementFormatType,    command: FORMAT_ELEMENT_COMMAND, title: 'Left Align',    icon: faAlignLeft },
    center:  { kind: 'element', elementFormatType: 'center' as ElementFormatType,  command: FORMAT_ELEMENT_COMMAND, title: 'Center Align',  icon: faAlignCenter },
    right:   { kind: 'element', elementFormatType: 'right' as ElementFormatType,   command: FORMAT_ELEMENT_COMMAND, title: 'Right Align',   icon: faAlignRight },
    justify: { kind: 'element', elementFormatType: 'justify' as ElementFormatType, command: FORMAT_ELEMENT_COMMAND, title: 'Justify Align', icon: faAlignJustify },
};

export function AlignmentItem({ editor, selected, definition: { title, icon, command, elementFormatType } }: { editor: LexicalEditor, selected: boolean, definition: Definition })
{
    const handleClick = () => editor.dispatchCommand(command, elementFormatType);
    return <ToolbarButton title={title} icon={icon} onClick={handleClick} selected={selected} />;
}

export default function Alignment()
{
    const [editor] = useLexicalComposerContext();
    const intl = useIntl();
    const translations = (intl as any).messages?.sharedComponents?.lexicalEditor?.toolbar;
    const [value, setValue] = useState<ElementFormatType>();
    useEffect(() =>
    {
        return editor.registerUpdateListener(({ editorState }) =>
        {
            editorState.read(() =>
            {
                const selection = $getSelection();
                if (!$isRangeSelection(selection)) { return; }
                const node = selection.anchor.getNode().getTopLevelElement();
                if (!node) { return; }
                const format = node.getFormatType();
                setValue(format);
            });
        });
    },
    [editor]);
    const element =
    <>
        <AlignmentItem editor={editor} selected={Definitions.left.elementFormatType === value} definition={{ ...Definitions.left, title: translations?.alignmentLeft ?? Definitions.left.title }} />
        <AlignmentItem editor={editor} selected={Definitions.center.elementFormatType === value} definition={{ ...Definitions.center, title: translations?.alignmentCenter ?? Definitions.center.title }} />
        <AlignmentItem editor={editor} selected={Definitions.right.elementFormatType === value} definition={{ ...Definitions.right, title: translations?.alignmentRight ?? Definitions.right.title }} />
        <AlignmentItem editor={editor} selected={Definitions.justify.elementFormatType === value} definition={{ ...Definitions.justify, title: translations?.alignmentJustify ?? Definitions.justify.title }} />
    </>;
    return element;
}